import Flickity from 'flickity'
import 'flickity/css/flickity.css'
import gsap from 'gsap'

function init() {
	document.querySelectorAll('[data-slider]').forEach(element => {
		const options = element.dataset.slider.startsWith('{') ? JSON.parse(element.dataset.slider) : {}

		// Do not initialize if there is only one child
		if (element.children.length < 2) return

		const slider = new Flickity(element, {
			on: {
				select: function (index) {
					const paragraphs = this.cells[index].element.querySelectorAll('p')
					gsap.to(paragraphs, {
						y: 0,
						opacity: 1,
					})
				}
			},
			...options
		})
	})
}

export { init }
